export const REPORT_STATUS = {
  OPEN: 'OPEN',
  RESOLVED: 'RESOLVED',
};
